import { QueryClient } from '@tanstack/react-query'
import config from '@config'

const {
  abTest: { windowKey },
} = config

export type FeatureFlagsEntries = (typeof config.abTest)['featureFlagsEntries']

const getABTestValue = <T extends keyof FeatureFlagsEntries>(
  abTestKey: T,
  queryClient: QueryClient
) =>
  queryClient.getQueryData<FeatureFlagsEntries[T]['values'][number]['name']>([
    windowKey,
    abTestKey,
  ])

export { getABTestValue }
